import { Controller } from "@hotwired/stimulus"

// also defined in entity/team.rb for back-end validation and title generation
const SPORTS_TO_GENDER_OPTIONS = {
  "Baseball": "men's",
  "Softball": "women's",
  "Volleyball": "choice",
  "Lacrosse": "choice",
  "Ice Hockey": "choice",
  "Field Hockey": "women's",
  "Wrestling": "choice",
  "Beach Volleyball": "women's",
  "Track and Field": "choice",
  "Cross Country": "choice",
  "Swimming": "choice",
  "Golf": "choice",
  "Gymnastics": "choice",
  "Water Polo": "choice",
  "Tennis": "choice",
  "Soccer": "choice",
  "Basketball": "choice",
  "Football": "men's",
  "Flag Football": "choice",
  "Basketball": "choice",
}

const SPORTS_TO_RECORD_STYLE_OPTIONS = {
  "Baseball": "winloss",
  "Softball": "winloss",
  "Volleyball": "winloss",
  "Lacrosse": "winloss",
  "Ice Hockey": "winloss",
  "Field Hockey": "winloss",
  "Wrestling": "both",
  "Beach Volleyball": "winloss",
  "Track and Field": "both",
  "Cross Country": "placement",
  "Swimming": "both",
  "Golf": "both",
  "Gymnastics": "both",
  "Water Polo": "winloss",
  "Tennis": "both",
  "Soccer": "winloss",
  "Basketball": "winloss",
  "Football": "winloss",
  "Basketball": "winloss",
  "Flag Football": "winloss"
}

export default class extends Controller {
  static targets = [ "sportSelect", "genderSelect", "recordStyleSelect", "genderSelectContainer", "recordStyleSelectContainer" ]

  connect() {
    // console.log("Hello, Entity Team Basics Controller here!", this.element);
    // console.log(this.genderSelectTarget);
    // console.log(this.sportSelectTarget);

    this.updateSport({ target: this.sportSelectTarget });
  }

  updateSport(event) {
    const sport = event.target.selectedOptions[0].innerText;
    // console.log(sport);

    this.updateGenderOptions(sport);
    this.updateRecordStyleOption(sport);
  }

  updateGenderOptions(sport) {
    const genderOption = SPORTS_TO_GENDER_OPTIONS[sport];
    // console.log(genderOption);

    if (genderOption === "men's") {

      this.genderSelectTarget.value = "men's";
      this.genderSelectContainerTarget.classList.remove("d-block");
      this.genderSelectContainerTarget.classList.add("d-none");

    } else if (genderOption === "women's") {

      this.genderSelectTarget.value = "women's";
      this.genderSelectContainerTarget.classList.remove("d-block");
      this.genderSelectContainerTarget.classList.add("d-none");

    } else if (genderOption === "choice") {

      // this.genderSelectTarget.value = "choice";
      this.genderSelectContainerTarget.classList.remove("d-none");
      this.genderSelectContainerTarget.classList.add("d-block");

    }

    // console.log(this.genderSelectTarget.value);
  }

  updateRecordStyleOption(sport) {
    const recordStyleOption = SPORTS_TO_RECORD_STYLE_OPTIONS[sport];
    // console.log(recordStyleOption);

    if (recordStyleOption === "winloss") {
      this.recordStyleSelectTarget.value = "winloss";
    } else if (recordStyleOption === "placement") {
      this.recordStyleSelectTarget.value = "placement";
    } else if (recordStyleOption === "both") {
      this.recordStyleSelectTarget.value = "both";
    }

    // console.log(this.recordStyleSelectTarget.value);
  }

}
